/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subrip_SrtInputs */

const en_subrip_srt = /** @type {(inputs: Subrip_SrtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SubRip (.srt)`)
};

const fr_subrip_srt = /** @type {(inputs: Subrip_SrtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SubRip (.srt)`)
};

const de_subrip_srt = /** @type {(inputs: Subrip_SrtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SubRip (.srt)`)
};

const it_subrip_srt = /** @type {(inputs: Subrip_SrtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SubRip (.srt)`)
};

const ru_subrip_srt = /** @type {(inputs: Subrip_SrtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SubRip (.srt)`)
};

const es_subrip_srt = /** @type {(inputs: Subrip_SrtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SubRip (.srt)`)
};

const zh_cn2_subrip_srt = /** @type {(inputs: Subrip_SrtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SubRip (.srt)`)
};

const ja_subrip_srt = /** @type {(inputs: Subrip_SrtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブリップ (.srt)`)
};

const hi_subrip_srt = /** @type {(inputs: Subrip_SrtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबरिप (.srt)`)
};

const pt_pt2_subrip_srt = /** @type {(inputs: Subrip_SrtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SubRip (.srt)`)
};

/**
* | output |
* | --- |
* | "SubRip (.srt)" |
*
* @param {Subrip_SrtInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subrip_srt = /** @type {((inputs?: Subrip_SrtInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subrip_SrtInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subrip_srt(inputs)
	if (locale === "de") return de_subrip_srt(inputs)
	if (locale === "it") return it_subrip_srt(inputs)
	if (locale === "ru") return ru_subrip_srt(inputs)
	if (locale === "es") return es_subrip_srt(inputs)
	if (locale === "zh-CN") return zh_cn2_subrip_srt(inputs)
	if (locale === "ja") return ja_subrip_srt(inputs)
	if (locale === "hi") return hi_subrip_srt(inputs)
	if (locale === "pt-PT") return pt_pt2_subrip_srt(inputs)
	return en_subrip_srt(inputs)
});